import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from 'store/store'
import {
  OrdersQueryVariables,
  StoreFrontOrderConnection,
} from 'lib/graphql/storefront'
import { STORES } from 'config'

export interface OrdersType {
  orders: StoreFrontOrderConnection
  variables?: OrdersQueryVariables
}

const initialState: OrdersType = {
  orders: null,
  variables: { stores: STORES },
}

// Slice
const OrdersSlice = createSlice({
  name: 'orders',
  initialState,
  reducers: {
    setOrdersFilter: (
      state,
      action: PayloadAction<StoreFrontOrderConnection>
    ) => {
      const { payload } = action
      state.orders = payload
    },
    setValueOrderFilter: (
      state,
      action: PayloadAction<OrdersQueryVariables>
    ) => {
      const { payload } = action
      state.variables = payload
    },
  },
})

// Selectors
export const getOrdersSelector = (
  state: RootState
): StoreFrontOrderConnection => state.orders.orders

export const getValueOrderFilterSelector = (
  state: RootState
): OrdersQueryVariables => state.orders.variables

// Actions
export const { setOrdersFilter, setValueOrderFilter } = OrdersSlice.actions

// Reducers
export default OrdersSlice.reducer
